import React from 'react';
import { Text, Box, HStack, Button, CloseButton } from '@chakra-ui/react';
import { useTour } from '../Tour/tour';
import { useNavigate } from 'react-router-dom';
import { SUPER_USER_ID } from '../../constants';

interface OnboardingTourItemProps {
	title: string;
	content: string;
	icon: React.ReactNode;
	index: number;
	shouldOpenTomChat?: boolean;
}

export const OnboardingTourItem: React.FC<OnboardingTourItemProps> = ({
	content,
	title,
	icon,
	index,
	shouldOpenTomChat,
}) => {
	const navigate = useNavigate();
	const { currentStep, setIsOpen, setCurrentStep, steps } = useTour();

	const isLastStep = currentStep === steps.length - 1;

	const handleNext = async () => {
		if (isLastStep) {
			setIsOpen(false);

			if (shouldOpenTomChat) {
				navigate(`/messenger/direct/${SUPER_USER_ID}`);
			}

			setTimeout(() => {
				setCurrentStep(0);
			}, 400);
		} else {
			setCurrentStep(index + 1);
		}
	};

	const handleClose = () => {
		setIsOpen(false);

		setTimeout(() => {
			setCurrentStep(0);
		}, 400);
	};

	return (
		<Box
			position="relative"
			bg="blue.100"
			p="16px"
			borderRadius="15px"
			borderTopLeftRadius={0}
			w="min(320px, calc(100vw - 32px))">
			<CloseButton
				position="absolute"
				top="8px"
				right="8px"
				color="white"
				aria-label="Close guide"
				onClick={handleClose}
			/>
			<Box
				position="relative"
				_before={{
					content: '""',
					height: '20px',
					width: '4px',
					backgroundColor: 'blue.50',
					position: 'absolute',
					left: 0,
					top: '2px',
					borderRadius: '1px',
				}}>
				<Text
					color="blue.50"
					fontSize="16px"
					lineHeight="24px"
					ml="10px">
					Introductory guide
				</Text>
			</Box>
			<HStack mt="12px" color="white">
				{icon}
				<Text
					color="mainBg"
					fontSize="16px"
					fontWeight={600}
					lineHeight="20px">
					{title}
				</Text>
			</HStack>
			<Text
				color="dropBlue"
				fontSize="14px"
				lineHeight="24px"
				mt="4px"
				mb="12px">
				{content}
			</Text>
			<HStack gap="16px">
				<Text color="blue.50" fontSize="14px" flexShrink={0}>
					{index + 1} of {steps.length}
				</Text>
				<Button
					onClick={handleNext}
					w="100%"
					variant={isLastStep ? 's8-solid' : 'tab-selected'}
					// isLoading={completeIntroductionMutation.isPending}
					height="40px"
					fontWeight="600"
					borderRadius="4px">
					{isLastStep
						? shouldOpenTomChat
							? 'Get in touch with Tom'
							: 'Finish'
						: 'Next'}
				</Button>
			</HStack>
		</Box>
	);
};
